import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component:()=>import('@/components/Welcome'),
      beforeEnter:(route, redirect, next)=>{
        if(location.href.indexOf("2020pad")>=0){
          next({path:'/welcomePad'})
        }
        else{
          next()
        }
      }
    },
    {
      path: '/welcomePad',
      name: 'WelcomePad',
      component:()=>import('@/components/WelcomePad')
    },
    {
      path: '/card',
      name: 'Card',
      component:()=>import('@/components/Card')
    },
    {
      path: '/cardpad',
      name: 'CardPad',
      component:()=>import('@/components/CardPad')
    },
    {
      path: '/receiveGold',
      name: 'ReceiveGold',
      component:()=>import('@/components/ReceiveGold')
    },
    {
      path: '/receiveGoldPad',
      name: 'ReceiveGoldPad',
      component:()=>import('@/components/ReceiveGoldPad')
    },
    {
      path: '/Redpacket',
      name: 'Redpacket',
      component:()=>import('@/components/Redpacket'),
      beforeEnter:(to,from,next)=>{
        if(from.path=='/receivegold'||from.path=='/sort'||from.path=='/card'||from.path=='/elevator'){
          next();
        }else{
          next({path:from.path})
        }
      }
    },
    {
      path: '/sort',
      name: 'Sort',
      component:()=>import('@/components/Sort')
    },
    {
      path: '/sortpad',
      name: 'SortPad',
      component:()=>import('@/components/SortPad')
    },
    {
      path: '/elevator',
      name: 'Elevator',
      component:()=>import('@/components/Elevator')
    },
    {
      path: '/elevatorpad',
      name: 'ElevatorPad',
      component:()=>import('@/components/ElevatorPad')
    },
    {
      path: '/isNotWechat',
      name: 'IsNotWechat',
      component:()=>import('@/components/IsNotWechat')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js